






































import { Component, Mixins, Prop } from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import Candidate from '@/evaluations/entities/candidate'

@Component
export default class CandidatesTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public items!: Candidate[]

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  private get headers() {
    return [
      {
        text: this.$tc('common.name.full'),
        value: 'name',
        sortable: false,
        width: '25%',
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
    ]
  }
}
